import type { JSX } from 'react'
import type { IButtonProps } from '../Button'

import { IconNames } from 'atoms/Icon/Icon.h'
import { COLOR } from 'vars/color'
import { Button } from '../Button'
import {
  ButtonBordersWidth,
  ButtonColors,
  ButtonCorners,
  ButtonFluid,
  ButtonFonts,
  ButtonIconSizes,
  IconPositions,
} from '../Button.h'

export interface IInlineForwardButtonProps extends IButtonProps {}

export const InlineForwardButton = ({
  icon = IconNames.arrowRight,
  iconPosition = IconPositions.Left,
  iconSize = ButtonIconSizes.medium,
  corners: _unused1 = ButtonCorners.CORNERS_10,
  colorDefault: _unused2 = ButtonColors.COLOR_PRIMARY,
  colorDisabled: _unused3 = ButtonColors.COLOR_DISABLED,
  backgroundColorDefault: _unused4 = COLOR.TRANSPARENT,
  backgroundColorDisabled: _unused5 = COLOR.TRANSPARENT,
  borderWidth: _unused6 = ButtonBordersWidth.BORDER_0,
  font: _unused7 = ButtonFonts.Button1,
  fluid: _unused8 = ButtonFluid.None,
  ...rest
}: IInlineForwardButtonProps): JSX.Element => {
  return (
    <Button
      icon={icon}
      iconPosition={iconPosition}
      iconSize={iconSize}
      corners={ButtonCorners.CORNERS_0}
      paddings={[]}
      colorDefault={ButtonColors.COLOR_PRIMARY}
      colorDisabled={ButtonColors.COLOR_DISABLED}
      backgroundColorDefault={COLOR.TRANSPARENT}
      backgroundColorDisabled={COLOR.TRANSPARENT}
      borderWidth={ButtonBordersWidth.BORDER_0}
      font={ButtonFonts.Button1}
      fluid={ButtonFluid.None}
      {...rest}
    />
  )
}
